import { firstOrNull } from 'common/utils/array';

import { useMerchantAdCampaign } from './useMerchantAdCampaign';
import { useVenueAdCampaign } from './useVenueAdCampaign';
import { useCampaignModuleContext } from '../../context';

export const useAdCampaign = ({ campaignId, enabled }: { campaignId: string; enabled: boolean }) => {
  const { entityType, venues, merchantId } = useCampaignModuleContext();
  const venueId = firstOrNull(venues)?.id ?? '';

  const venueCampaignResponse = useVenueAdCampaign({ venueId, campaignId, enabled: enabled && entityType === 'venue' });

  const merchantCampaignResponse = useMerchantAdCampaign({
    merchantId,
    campaignId,
    enabled: enabled && entityType === 'merchant',
  });

  return entityType === 'venue' ? venueCampaignResponse : merchantCampaignResponse;
};
